<template>
  <aside class="conversation-list favorite-list">
    <header class="list-header">
      <div>
        <h2>收藏</h2>
        <p>{{ conversations.favoriteMessages.length }} 条消息</p>
      </div>
    </header>
    <div class="sidebar-scroll">
      <button
        v-for="item in conversations.favoriteMessages"
        :key="item.key"
        type="button"
        class="favorite-item"
        :class="{ active: activeKey === item.key }"
        @click="selectFavorite(item.key)"
      >
        <span class="favorite-item-icon">★</span>
        <span class="favorite-item-main">
          <strong>{{ favoriteTitle(item) }}</strong>
          <small>{{ favoritePreview(item) }}</small>
        </span>
        <time>{{ formatFavoriteTime(item.timestamp) }}</time>
      </button>
      <div v-if="!conversations.favoriteMessages.length" class="empty-list">
        暂无收藏消息
      </div>
    </div>
  </aside>
</template>

<script setup>
import { computed } from 'vue';
import { useConversationStore } from '@/stores/conversations';

const conversations = useConversationStore();
const emit = defineEmits(['detail-open']);
const activeKey = computed(() => conversations.activeFavorite?.key || '');

function selectFavorite(key) {
  conversations.setActiveFavorite(key);
  emit('detail-open');
}

function favoriteTitle(item) {
  if (item.conversationTitle) {
    return item.conversationTitle;
  }
  const conversation = conversations.conversations.find(entry => entry.id === item.conversationId);
  return conversation?.title || item.conversationId || '未知会话';
}

function favoritePreview(item) {
  if (item.recalled) {
    return `[${item.recallStatus || '已撤回'}]`;
  }
  if (item.preview) {
    return item.preview;
  }
  if (item.text) {
    return item.text;
  }
  if (item.type === 'image') {
    return '[图片]';
  }
  if (item.type === 'file') {
    return `[文件] ${item.attachment?.name || '文件'}`;
  }
  return '（无文字内容）';
}

function formatFavoriteTime(timestamp) {
  const value = Number(timestamp || 0);
  if (!value) {
    return '';
  }
  return new Intl.DateTimeFormat('zh-CN', {
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).format(value);
}
</script>
